import { env } from '@/lib/env';

/**
 * How a clinic reaches Bookora's own support desk.
 *
 * ── WHY THIS EXISTS ─────────────────────────────────────────────────────────
 *
 * Several server messages end «با پشتیبانی تماس بگیرید» — a suspended clinic, a
 * deactivated account, a lost second factor — and the staff screen tells an
 * owner to ask «پشتیبانی بوکورا» to fix a clinic with no owner. For months the
 * panel had no phone number, link or help entry anywhere, so every one of those
 * sentences was a dead end. This is the one place the contact lives, and every
 * surface that says "contact support" renders it rather than repeating it.
 *
 * ── WHERE THE VALUES COME FROM ──────────────────────────────────────────────
 *
 * Build-time, like everything in `lib/env.ts` (`VITE_SUPPORT_PHONE`,
 * `VITE_SUPPORT_TELEGRAM`, `VITE_SUPPORT_EMAIL`). The phone and the Telegram
 * handle are EMPTY by default, for the reason `web/src/config/site.ts` leaves
 * its phone unset: a number nobody answers is worse than no number. A channel
 * that is not configured is simply not drawn. The contact form on the public
 * site and the support mailbox always exist, so the list is never empty.
 */
export const SUPPORT = {
  phone: String(import.meta.env.VITE_SUPPORT_PHONE ?? '').trim(),
  telegram: String(import.meta.env.VITE_SUPPORT_TELEGRAM ?? '')
    .trim()
    .replace(/^@/, ''),
  email: String(import.meta.env.VITE_SUPPORT_EMAIL ?? '').trim() || 'support@bookora.net',
  /** Same hours the public site's contact page shows. */
  hours: 'شنبه تا چهارشنبه ۹ تا ۱۸، پنج‌شنبه ۹ تا ۱۳',
  contactPage: `${env.siteUrl}/contact`,
} as const;
